import lru from "quick-lru";
import type { ISearchHistoryDto } from "../../../dtos/search-history.dto";
import type { ISearchHistoryCachedDatasource } from "./search-history-cached.datasource.interface";

const SEARCH_HISTORY_CACHE_SIZE = 1;
const SEARCH_HISTORY_CACHE_MAX_AGE_MILLIS = 30_000;

export class SearchHistoryCachedDatasource implements ISearchHistoryCachedDatasource {
  private readonly _SEARCH_HISTORY_CACHE_KEY = "searchHistory";

  constructor(
    private readonly _searchHistoryCache = new lru<string, ISearchHistoryDto>({
      maxSize: SEARCH_HISTORY_CACHE_SIZE,
      maxAge: SEARCH_HISTORY_CACHE_MAX_AGE_MILLIS,
    })
  ) {}

  getSearchHistory(): ISearchHistoryDto | undefined {
    return this._searchHistoryCache.get(this._SEARCH_HISTORY_CACHE_KEY);
  }

  setSearchHistory(searchHistory: ISearchHistoryDto) {
    this._searchHistoryCache.set(this._SEARCH_HISTORY_CACHE_KEY, searchHistory);
  }
}
